export const SortField = {
  ASIN: 'asin',
  BRAND: 'brand',
  TITLE: 'title',
  FINAL_SCORE: 'finalScore',
  TOTAL_REVIEWS: 'totalReviews',
  PROJECTED_LIFT: 'projectedLift'
} as const;
export type SortFieldType = (typeof SortField)[keyof typeof SortField];

export const SortDirection = {
  ASC: 'asc',
  DESC: 'desc'
} as const;
export type SortDirectionType = (typeof SortDirection)[keyof typeof SortDirection];

export const ITEMS_PER_PAGE = 8;
